import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';

interface StatusCardProps {
  to: string;
  icon: LucideIcon;
  label: string;
  primary: string;
  secondary?: string;
  tone?: 'ok' | 'warn' | 'error' | 'idle';
}

const toneClasses: Record<NonNullable<StatusCardProps['tone']>, string> = {
  ok:    'border-green-200 dark:border-green-800 bg-green-50 dark:bg-green-900/20',
  warn:  'border-yellow-200 dark:border-yellow-800 bg-yellow-50 dark:bg-yellow-900/20',
  error: 'border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-900/20',
  idle:  'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800',
};

export function StatusCard({ to, icon: Icon, label, primary, secondary, tone = 'idle' }: StatusCardProps) {
  return (
    <Link
      to={to}
      className={`block rounded-lg border p-4 hover:shadow-sm transition ${toneClasses[tone]}`}
    >
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">{label}</span>
        <Icon className="h-4 w-4 text-gray-400 dark:text-gray-500" />
      </div>
      <div className="mt-2 text-2xl font-semibold text-gray-900 dark:text-gray-100">{primary}</div>
      {secondary && <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">{secondary}</div>}
    </Link>
  );
}
